module.exports = __webpack_public_path__ + "img/id.818adec2.png";